module.exports = __webpack_public_path__ + "img/1-4.971e3365.jpg";